import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLoveShots } from '../../store/slices/loveshotsSlice';
import LoveShotCard from '../../components/features/loveshots/LoveShotCard';
import CreateLoveShot from '../../components/features/loveshots/CreateLoveShot';
import { StoryBar } from '../../components/features/stories';
import PageHeader from '../../components/common/PageHeader';
import { FaSpinner, FaPlus } from 'react-icons/fa';
import './Home.css';


const Home = () => {
  const dispatch = useDispatch();
  const { items: loveshots, loading, hasMore, currentPage } = useSelector((state) => state.loveshots);
  const [loadingMore, setLoadingMore] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);

  useEffect(() => {
    if (loveshots.length === 0) {
      dispatch(fetchLoveShots({ page: 1 }));
    }
  }, [dispatch, loveshots.length]);

  const loadMore = async () => {
    if (hasMore && !loadingMore) {
      setLoadingMore(true);
      await dispatch(fetchLoveShots({ page: currentPage + 1 }));
      setLoadingMore(false);
    }
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 100 && hasMore && !loadingMore) {
      loadMore();
    }
  };

  return (
    <div className="home-page">
      <PageHeader
        title="Où l'Amour Commence"
        subtitle="Découvrez des connexions authentiques et partagez des moments magiques"
        button={{
          text: "Créer un LoveShot",
          icon: FaPlus,
          onClick: () => setShowCreateModal(true)
        }}
      />

      <StoryBar />

      <div className="home-content" onScroll={handleScroll}>

        {loading && loveshots.length === 0 ? (
          <div className="loading-container">
            <FaSpinner className="spinner" />
            <p>Chargement des LoveShots...</p>
          </div>
        ) : loveshots.length > 0 ? (
          <div className="loveshots-feed">
            {loveshots.map((loveshot) => (
              <LoveShotCard key={loveshot.id} loveshot={loveshot} />
            ))}
            {loadingMore && (
              <div className="loading-more">
                <FaSpinner className="spinner" />
                <p>Chargement de plus de LoveShots...</p>
              </div>
            )}
            {!hasMore && loveshots.length > 0 && (
              <div className="end-of-feed">
                <p>Vous avez vu tous les LoveShots ! 💕</p>
              </div>
            )}
          </div>
        ) : (
          <div className="empty-feed">
            <h3>Aucun LoveShot pour le moment</h3>
            <p>Soyez le premier à partager votre amour ! 💕</p>
            <button className="create-first-loveshot-btn" onClick={() => setShowCreateModal(true)}>
              <FaPlus /> Créer le premier LoveShot
            </button>
          </div>
        )}
      </div>

      <CreateLoveShot
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
      />
    </div>
  );
};

export default Home;
